// Chakra imports
import {
    Box,
    Button,
    FormControl,
    Progress,
    Input,
    Text,
    Select,
    useColorModeValue,
    Badge,
    VStack
  } from "@chakra-ui/react";
  // Assets
  import BgSignUp from "assets/img/BgSignUp.png";
  import React, { useState, useEffect } from "react";
  import { FaApple, FaFacebook, FaGoogle } from "react-icons/fa";
  import Card from "components/Card/Card.js";
  import CardBody from "components/Card/CardBody.js";
  import CardHeader from "components/Card/CardHeader.js";
  import { useAppContext } from "../../../../context/appContext";
  import { getCustomer, getProducts, createOrderCuota, updateCustomer } from "../../../../services/woo";
  import { arancelesList } from "../../../../services/cursosList";

  function BatchUsersGroup({title, customers, groupList}) {
    const titleColor = useColorModeValue("teal.300", "teal.200")
    const textColor = useColorModeValue("gray.700", "white")
    const bgColor = useColorModeValue("white", "gray.700")
    const bgIcons = useColorModeValue("teal.200", "rgba(255, 255, 255, 0.5)")
    const { handleUpdateData } = useAppContext()
    const [month, setMonth] = useState("2023-03")
    const [log, setLog] = useState([])
    const [loading, setLoading] = useState(false)
    const [ordersCreated, setOrdersCreated] = useState([])
    const [progress, setProgress] = useState(0)
    const [valueGroup, setValueGroup] = useState(false)

    const updateGroup = async () => {
        setLoading(true)
        setOrdersCreated([])

        // const ordersCreated = []
        for (const customer of customers) {
            // Obtenermos la informacion actualizada del cliente
            const customer_id = customer.id
            const getCustomerInfo = await getCustomer(customer_id)
            const { meta_data } = getCustomerInfo.data;
            const customer_suscription_name = _.find(meta_data, { key: 'suscription_name' })?.value;
            const customer_group_name = _.find(meta_data, { key: 'group_name' })?.value;
            // const product_found = _.find(products, { name: customer_suscription_name }) // Buscar si existe la suscripción
            if (!valueGroup) {
                alert('Debes seleccionar el grupo que se moveran los clientes')
                setLoading(false);
                return;
            }

            // Actualizar el estado de la suscripción y grupo del cliente
            const meta_data_customer = {
                meta_data: [ 
                { key: "group_name", value: valueGroup == 'empty' ? '' : valueGroup},
                ]
            };
            const customerUpdated = await updateCustomer(customer_id, meta_data_customer)
            console.log(customerUpdated)
            setOrdersCreated(ordersCreated => [...ordersCreated, customerUpdated.create])

            const porcentajeCompletado = (ordersCreated.length / customers.length) * 100
            console.log(porcentajeCompletado)
            setProgress(porcentajeCompletado)

            console.log(customerUpdated)
        }
        setLoading(false);
        handleUpdateData()
        setLog([...log, {'order_created' : ordersCreated}])

    }

    useEffect(() => {
        console.log(groupList)
    }, [])

    return (
      <VStack spacing={4} align="stretch">
        <Text fontSize={'lg'} fontWeight="semibold">
          <Badge fontSize='0.8em' colorScheme='teal' mr={2}>
            {customers.length} usuarios seleccionados
          </Badge>
          Selecciona el nuevo grupo
        </Text>

        <FormControl>
          <Select 
            value={valueGroup} 
            onChange={(e) => setValueGroup(e.target.value)}
            placeholder="Seleccionar grupo"
            size="lg"
          >
            <option value="empty">SIN GRUPO ASIGNADO</option>
            {groupList && groupList.map((group) => (
              <option key={group.name} value={group.name}>
                {group.name}
              </option>
            ))}
          </Select>
        </FormControl>

        {ordersCreated.length > 0 && (
          <Box>
            <Text fontSize="sm" color="gray.600" mb={2}>
              Progreso: {ordersCreated.length} de {customers.length} usuarios actualizados
            </Text>
            <Progress 
              value={(ordersCreated.length / customers.length) * 100} 
              colorScheme="teal" 
              borderRadius="md"
            />
          </Box>
        )}

        <Button
          colorScheme="teal"
          size="lg"
          onClick={() => updateGroup()}
          isLoading={loading}
          isDisabled={!valueGroup}
        >
          MOVER USUARIOS AL GRUPO
        </Button>
      </VStack>
    );
  }
  
export default BatchUsersGroup;
  